import React from 'react';

export default React.createContext({
  theme: 'dark',
  language: 'EN',
  setLanguage: () => {},
  setTheme: () => {},
});
